const $ = jQuery;

const Faq = {
  init: function () {
    const firstItem = $(".faq").first();
    const firstContent = firstItem.find(".answer");

    firstItem.addClass("active");
    firstContent.slideDown();

    $(".question").on("click", (e) => {
      const parent = $(e.target).closest(".faq");
      const content = parent.find(".answer");
      const activeItem = $(".faq.active");

      if (!parent.hasClass("active")) {
        if (activeItem.length > 0) {
          const activeContent = activeItem.find(".answer");
          activeContent.slideUp();
          activeItem.removeClass("active");
        }

        content.slideDown();
        parent.addClass("active");
      }
    });
    
    $(".faq-shop--question").on("click", (e) => {
      const parent = $(e.target).closest(".faq-shop-item");
      const content = parent.find(".faq-shop--answer");
      const activeItem = $(".faq-shop-item.active"); 
      if (!parent.hasClass("active")) {
        if (activeItem.length > 0) {
          const activeContent = activeItem.find(".faq-shop--answer");
          activeContent.slideUp();
          activeItem.removeClass("active");
        }
    
        content.slideDown();
        parent.addClass("active");
      } else {
        content.slideUp();
        parent.removeClass("active");
      }
    });
  },
};

export default Faq;
